import { Alert, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function FillNullsInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="Strategy for picking a fill value">Method</FieldLabel>
      <Segmented
        value={c.method || 'constant'}
        onChange={(v) => u({ method: v })}
        options={[
          { value: 'constant', label: 'Constant' },
          { value: 'mean', label: 'Mean' },
          { value: 'mode', label: 'Mode' },
          { value: 'ffill', label: 'Forward' },
        ]}
      />
      {(c.method || 'constant') === 'constant' && (
        <>
          <FieldLabel>Fill value</FieldLabel>
          <TextInput value={c.fill} onChange={(v) => u({ fill: v })} placeholder="e.g. UNKNOWN" />
        </>
      )}
      <Alert kind="info" style={{ marginTop: 12 }}>
        Mean / mode / forward-fill are computed from the rows entering this step.
      </Alert>
      {c.method === 'mean' && (
        <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
      )}
    </div>
  );
}
